// Keep legacy URIs, and expose ordinary single-host connections as editable fields.
export function mongoConnectionForm(config) {
  const result = { ...config };
  const legacyHost = (config.host || "").trim();
  const uri = (config.uri || (legacyHost.startsWith("mongodb") ? legacyHost : "")).trim();
  if (!uri) return { mode: "fields", config: result };
  result.uri = uri;
  try {
    const parsed = new URL(uri);
    if (parsed.protocol !== "mongodb:" || parsed.hostname.includes(",")) {
      return { mode: "uri", config: result };
    }
    const options = [...parsed.searchParams.entries()];
    const canUseFields = options.every(([key, value]) => (
      (key.toLowerCase() === "authsource" && value === "admin") ||
      (key.toLowerCase() === "directconnection" && value === "true")
    )) && options.some(([key, value]) => key.toLowerCase() === "directconnection" && value === "true");
    return {
      mode: canUseFields ? "fields" : "uri",
      config: {
        ...result,
        host: parsed.hostname,
        port: parsed.port || "27017",
        username: decodeURIComponent(parsed.username),
        password: decodeURIComponent(parsed.password),
        database: (config.database || "").trim() || decodeURIComponent(parsed.pathname.replace(/^\//, "")),
      },
    };
  } catch {
    return { mode: "uri", config: result };
  }
}

export function mongoUriFromFields(config) {
  let host = (config.host || "").trim();
  if (host.includes(":") && !host.startsWith("[")) host = `[${host}]`;
  const username = (config.username || "").trim();
  const credentials = username
    ? `${encodeURIComponent(username)}:${encodeURIComponent(config.password || "")}@`
    : "";
  return `mongodb://${credentials}${host}:${config.port || "27017"}/?authSource=admin&directConnection=true`;
}

export function businessConnectionPayload(form, mongoMode) {
  return {
    ...form,
    db_config: {
      ...form.db_config,
      ...(form.db_type === "mongodb" && mongoMode === "fields" ? { uri: "", clear_uri: true } : {}),
    },
  };
}
